
import { defineComponent, ref } from 'vue';

export default defineComponent({
    async setup() {
        return {};
    }
});
